import React from "react";
import { useGetDividendsPerYear } from "@bn/api/apiv1";
import { DividendsBaseChart } from "./DividendsBaseChart";

interface Props {
  isin?: string;
  currency?: string;
}

export const DividendsChart = ({ isin, currency }: Props) => {
  const { data, isFetching } = useGetDividendsPerYear(
    { isin, currency, predictNumberOfYears: 2 },
    { enabled: !!isin }
  );

  return (
    <DividendsBaseChart
      dividends={data?.dividendsPerYear}
      currency={currency}
      isFetching={isFetching}
    />
  );
};
